export default (props, {
  colors,
  effects,
  rhythm,
  scale,
  treatments
}) => ({
  link: {
    display: 'inline-block',
    verticalAlign: 'middle'
  },

  image: {
    maxWidth: rhythm(8),
    maxHeight: rhythm(4)
  }
})



// WEBPACK FOOTER //
// ./components/slices/FeaturedCharities/Charity/styles.js